function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", {
  fill: "#000000"
}, /*#__PURE__*/React.createElement("style", null, ".trash-icon{fill:none;stroke:#808080;stroke-miterlimit:10;stroke-width:0.7px;}"));
var _ref3 = /*#__PURE__*/React.createElement("line", {
  className: "trash-icon",
  x1: 4.62,
  y1: 6.02,
  x2: 4.62,
  y2: 13.6,
  fill: "#000000"
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "trash-icon",
  x1: 6.63,
  y1: 6.02,
  x2: 6.63,
  y2: 13.6,
  fill: "#000000"
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "trash-icon",
  x1: 8.63,
  y1: 6.02,
  x2: 8.63,
  y2: 13.6,
  fill: "#000000"
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "trash-icon",
  x: 1.55,
  y: 3.95,
  width: 10.1,
  height: 11.45,
  fill: "#000000"
});
var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "trash-icon",
  points: "10.04 1.69 9.52 0.35 3.69 0.35 3.17 1.69 0.35 1.69 0.35 2.71 12.86 2.71 12.86 1.69 10.04 1.69",
  fill: "#000000"
});
function SvgTrashGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 13.21 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trashcan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrey);
export default __webpack_public_path__ + "static/media/Trash-grey.448bd44c.svg";
export { ForwardRef as ReactComponent };